import { Chip } from "@material-ui/core";
import { green, red, yellow } from "@material-ui/core/colors";
import BlockIcon from "@material-ui/icons/Block";
import CheckIcon from "@material-ui/icons/Check";
import DeleteIcon from "@material-ui/icons/Delete";
import HourglassEmptyIcon from "@material-ui/icons/HourglassEmpty";
import { get } from "lodash";
import React from "react";
import { useTranslate } from "react-admin";

const STATUS_COLOR_MAP = {
	pending: yellow[700],
	complete: green[500],
	deleted: red[400],
};

const STATUS_ICON_MAP = {
	pending: HourglassEmptyIcon,
	complete: CheckIcon,
	deleted: DeleteIcon,
};
const StatusField = ({ source, record }) => {
	const translate = useTranslate();
	const status = get(record, source);
	const Icon = get(STATUS_ICON_MAP, status, BlockIcon);
	const color = get(STATUS_COLOR_MAP, `${status}`, "");
	return (
		<Chip
			icon={<Icon style={{ color: "white" }} />}
			style={{
				backgroundColor: color,
				color: "white",
			}}
			label={translate(`resources.user-wtrs.status.${status}`)}
		/>
	);
};

export default StatusField;
